import React from 'react';
import propTypes from 'prop-types';
import Select from 'components/multi-select';
import DatePicker from './DatePicker';
import config from '../../../../../config';
import {jsUcfirst} from '../../../../../utils/General';
import SearchByColumn from "./SearchByColumn";
import {t} from "../../../../../components/Translate";

const styles = {
    thead: {
        position: 'sticky', top: '0', zIndex: '1', background: 'white'
    },
    cell: {
        height: '60px',
        fontWeight: 'normal',
        textAlign: 'left',
        paddingBottom: '20px',
        paddingLeft: '5px',
        paddingRight: '5px',
        width: '170px',
        minWidth: '165px',
    },
};

const Header = ({
                    company,
                    handleFilterChange,
                    selectedClientsIds,
                    selectedOperatorsIds,
                    selectedChannel,
                    selectedStatuses,
                    language,
                    startDate,
                    endDate,
                    handleDateChange,
                    handleUserKeySearch,
                    user
                }) => {

    const clientOptions = company.subs
        .map(client => ({
            id: client.id,
            title: client.name,
        }));

    const operatorOptions = company.members
        .filter(operator => operator.status === config.statusMap.enabled)
        .map(operator => ({
            id: operator.id,
            title: `${operator.firstName} ${operator.lastName}`,
        }));
    operatorOptions.unshift({
        id: -1,
        title: t({text: "noOperator", user}),
    });

    const platformsArray = Object.values(config.platformsMap);
    const platformOptions = platformsArray
        .filter(platform => platform !== config.platformsMap.company)
        .map(platform => ({
            id: platform,
            title: jsUcfirst(platform),
        }));

    const statusesOptions = config.conversationStatusesList
        .map(data => ({
            id: data,
            title: t({text: data, user}),
        }));


    return (
        <thead style={styles.thead}>

        <tr>
            <th style={{...styles.cell, width: '200px'}}>
                <SearchByColumn handleSearch={handleUserKeySearch} placeholder={'user'}/>
            </th>

            <th style={styles.cell}>
                <Select
                    titleKey="bot"
                    options={clientOptions}
                    handleSelect={(selectedIds) => {
                        handleFilterChange('selectedClientIds', selectedIds);
                    }}
                    selectedIds={selectedClientsIds}
                />
            </th>

            <th style={{...styles.cell, width: '205px'}}>
                <Select
                    titleKey="operator"
                    options={operatorOptions}
                    handleSelect={(selectedIds) => {
                        handleFilterChange('selectedOperatorsIds', selectedIds);
                    }}
                    selectedIds={selectedOperatorsIds}
                />
            </th>

            <th style={{...styles.cell, width: '150px'}}>
                <Select
                    titleKey="channel"
                    options={platformOptions}
                    handleSelect={(selectedIds) => {
                        handleFilterChange('selectedChannel', selectedIds);
                    }}
                    selectedIds={selectedChannel}
                />
            </th>

            <th style={{...styles.cell, width: '205px'}}>
                <Select
                    titleKey="Status"
                    options={statusesOptions}
                    handleSelect={(selectedIds) => {
                        handleFilterChange('selectedStatuses', selectedIds);
                    }}
                    selectedIds={selectedStatuses}
                />
            </th>

            <th style={styles.cell}>
                <DatePicker
                    language={language}
                    startDate={startDate}
                    endDate={endDate}
                    handleDateChange={handleDateChange}
                />
            </th>
        </tr>
        </thead>
    );
};

Header.propTypes = {
    company: propTypes.object.isRequired,
    handleFilterChange: propTypes.func.isRequired,
    selectedClientsIds: propTypes.array.isRequired,
    selectedOperatorsIds: propTypes.array.isRequired,
    selectedChannel: propTypes.array.isRequired,
    selectedCustomer: propTypes.string.isRequired,
    language: propTypes.string.isRequired,
    startDate: propTypes.object.isRequired,
    endDate: propTypes.object.isRequired,
    handleDateChange: propTypes.func.isRequired,

};

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/Header.jsx